import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { MediaItemDto, PaginatedDto, PaginationParamsDto } from '../models';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getMedia(value: PaginationParams): Observable<PaginatedDto> {
        return this.httpClient
            .get<MediaItemDto[]>('media', {
                params: new PaginationParamsDto(value).params,
                observe: 'response',
            })
            .pipe(map((response) => new PaginatedDto(response)));
    }
}
